/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { COIN_ICON_KEYS, DEFAULT_COIN_ICON } from "./icons";

export type IconPickerProps = {
  value: string | null;
  onChange: (icon: string | null) => void;
};

export const IconPicker = defineComponent<IconPickerProps>({
  name: "IconPicker",
  props: ["value", "onChange"],
  setup(props) {
    const { t } = useLocalization();

    const swatch = (icon: string, key: string | null, label: string) => {
      const selected = props.value === key;
      return (
        <button
          key={icon}
          type="button"
          title={label}
          aria-label={label}
          aria-pressed={selected}
          onClick={() => props.onChange(key)}
          class={`w-11 h-11 rounded-xl flex items-center justify-center border transition-colors ${
            selected
              ? "border-primary bg-primary/10 text-primary"
              : "border-base-300 text-base-content/60 hover:border-base-content/30 hover:text-base-content"
          }`}
        >
          <span class="material-symbols-outlined text-xl">{icon}</span>
        </button>
      );
    };

    return () => (
      <div class="flex flex-wrap gap-2">
        {swatch(DEFAULT_COIN_ICON, null, t("promotions.coins.icon_default"))}
        {COIN_ICON_KEYS.map((icon) =>
          swatch(icon, icon, t(`promotions.coins.icon_${icon}`)),
        )}
      </div>
    );
  },
});
